import { render } from "./GradesPicker.vue?vue&type=template&id=39d0cbee"
import script from "./GradesPicker.vue?vue&type=script&lang=js"
export * from "./GradesPicker.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__